<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-04 10:55:51
 * @Description: 忘记密码 输入账号
-->
<template>
	<div>
		<a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
			<a-form-model-item :label="$t('login.forget.step_one')" prop="username">
				<a-input v-model="form.username" :placeholder="$t('login.username_placeholder')" />
			</a-form-model-item>
			<a-form-model-item :label="$t('base.captcha.label')" class="valid-mask" prop="captcha">
				<a-input v-model="form.captcha" :placeholder="$t('base.captcha.img_placeholder')" />
				<img class="valid-mask-img" :src="validMaskImage" alt="" @click="getValidMask" />
			</a-form-model-item>
		</a-form-model>

		<div class="next">
			<a-button style="width: 440px" type="primary" @click="handleNext">{{ $t("base.btn.next_step") }}</a-button>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";

export default {
	data() {
		return {
			labelCol: { span: 6 },
			wrapperCol: { span: 14 },
			form: { username: "", captcha: "", captchaKey: "" },
			rules: {
				username: [{ required: true, message: this.$t("login.username_placeholder") }],
				captcha: [{ required: true, message: this.$t("base.captcha.img_placeholder") }],
			},
			validMaskImage: "",
		};
	},
	created() {
		this.getValidMask();
	},
	methods: {
		// 得到验证码图片
		async getValidMask() {
			const { code, data } = await commonAPI.getAction("/user/active/captcha");
			if (code === 0) {
				this.validMaskImage = data.image;
				this.form.captchaKey = data.captchaKey;
			}
		},
		// 下一步
		handleNext() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.handleNextApi();
				} else {
					return false;
				}
			});
		},
		async handleNextApi() {
			let params = { ...this.form };
			const { code, data, message } = await commonAPI.postAction("/password/reset/checkUserInfo", params);
			if (code == 0) {
				let obj = { username: this.form.username, secretKey: data };
				localStorage.setItem("FORGET_INFO", JSON.stringify(obj));
				this.$message.success(message);
				this.$emit("next", 1);
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.next {
	padding-top: 20px;
	text-align: center;
}
.valid-mask::v-deep {
	.ant-form-item-children {
		display: flex;
		height: 40px;
		justify-content: space-between;
		align-items: center;
		.ant-input {
			width: calc(100% - 110px);
		}
		.valid-mask-img {
			width: 100px;
			height: 32px;
			cursor: pointer;
		}
	}
}
</style>
